// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","headline":"_2VZ8OfV6pCjbZciF18Vn1A","body":"_2lYHSCAcM6vA2s-47YYZeS","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","borderGrey":"#d5dfdf","extraSmallMaxWidth":"767px","container":"_-8UYKZV3kDKZwJchRPoW4","title":"_2BlLJyBm6KzLDPSHMkZLLz _2VZ8OfV6pCjbZciF18Vn1A","subtotal":"_2sShtN7rAbXAO1Nj3Y9uM7 _2lYHSCAcM6vA2s-47YYZeS","price":"oGdwjsoFpVGuANN8igHek _2VZ8OfV6pCjbZciF18Vn1A","separator":"_3vKRHJe4serVfYF5wAhDQA","continueButton":"xf1vgHU4dh5xeh3vCuqrS","totalsContainer":"_2rxrAXvwGoKSdYk-h-8xcf"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/cart/summary/Summary.css
// module id = 426
// module chunks = 0 1 2